<scitis-app-global-page-header [pageTitle]="pageTitle">

  <ng-template #filterElement>
    <div class="page-functions">
      <button (click)="onImportCategories()"
              [disabled]="!isSuperAdminRole"
              class="btn btn-outline-primary">
        <span translate>Import categories</span>
      </button>
    </div>
  </ng-template>

  <ng-template #filterElement>
    <div class="page-functions">
      <button (click)="onAddCategory()"
              [disabled]="!isSuperAdminRole"
              class="btn btn-primary mr-2">
        <span class="fa-solid fa-plus"></span>
        <span translate>New category</span>
      </button>
    </div>
  </ng-template>
</scitis-app-global-page-header>

<div class="card card-table-view mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table vertical-align-middle mb-0">
        <thead>
        <tr>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="name" style="width:20%">
            <span translate>Category name</span>
          </th>
          <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="displayName" style="width:20%">
            <span translate>Display name</span>
          </th>
          <th style="width:20%">
            <span translate>Tags</span>
          </th>
          <th class="text-end" scope="col">
            <span translate>Action</span>
          </th>
        </tr>
        </thead>
        <tbody>

        <tr *ngFor="let category of machineCategoryList">
          <td>
            <strong>
              <div class="form-row align-items-center">
                <div class="col-auto">
                  <div class="image-circle">
                    <img [src]="category.icon" alt="">
                  </div>
                </div>
                <div class="col">
                  <ngb-highlight [result]="category.name" [term]="searchTerm"></ngb-highlight>
                </div>
              </div>
            </strong>

          </td>
          <td>
            <ngb-highlight [result]="category.displayName" [term]="searchTerm"></ngb-highlight>
          </td>
          <td>
            <span class="badge badge-light mr-2">Tag 01</span>
            <span class="badge badge-light mr-2">Tag 02</span>
            <span class="badge badge-light mr-2">Tag 03</span>
            <span class="badge">+ 14</span>
          </td>
          <td class="text-end">
            <scitis-machine-category-actions (machineCategoryDeleteEvent)="onDeleteMachineCategory(category)"
                                             (machineCategoryUpdatedEvent)="onMachineCategoryUpdated($event)"
                                             [machineCategory]="category"
                                             [isSuperAdminRole]="isSuperAdminRole"
                                             [searchTerm]="searchTerm">
            </scitis-machine-category-actions>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
